<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/wuhou/3/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            支持重点企业建立博士后科研工作站、创新实践基地，为新建平台发放建站资助；对新进入武侯区博士后科研工作站和创新实践基地的博士后人才，在站期间给予生活资助；对出站后留武侯区工作的博士后人才，给予资金奖励。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/3/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            博士后科研工作站或创新实践基地、博士后。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/1/title2.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.8rem">
              <div class="title">博士后设站资助</div>
              武侯区新获批设立的博士后科研工作站（不含分站）和博士后创新实践基地，在招收1名及以上博士后人员进站从事科研工作以后，给予单位一次性设站资助10万元，主要用于设站单位开展博士后研究工作而购置的仪器设备、软件资料、实验材料等支出。工作站和基地自获批之日起5年内未招收博士后人员进站的，不享受本项设站资助政策。
            </div>
            <div class="des" style="margin-top: 0.8rem">
              <div class="title">博士后生活资助</div>
              对新进入武侯区博士后科研工作站和博士后创新实践基地的博士后人才，在站期间每人每年给予5万元生活资助，资助期2年。博士后生活资助由博士后本人支配使用。
            </div>
            <div class="des" style="margin-top: 0.8rem">
              <div class="title" style="width: 5rem">
                博士后出站留武侯区工作奖励
              </div>
              <div style="margin-bottom: 0.1rem;">
                对武侯区博士后科研工作站和博士后创新实践基地新出站留武侯区企业工作的博士后人员，工作满1年后给予每人10万元奖励。博士后出站留武侯区奖励由博士后本人支配使用。
              </div>
              <!-- <br /> -->
              博士后人员进站时间以中国博士后管理系统生成的《博士后研究人员进站备案证明》上的落款时间为准；出站时间以《博士后证书》上的落款时间为准。本细则规定的博士后生活资助政策与本市、区博士安家补贴、博士生活补贴、优秀海外高校毕业生创新创业补贴政策均不重复享受。设站单位或博士后人员不按当年申报通知要求提交资助申请的，视为放弃资助。<br />
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/1/title3.png" alt="" />
          <div class="content">
            <div class="des" style="padding-top: 0.1rem">
              <div class="commonCircle">
                <div
                  class="commonCircle-circle"
                  style="margin-right: 0.15rem"
                ></div>
                <div class="commonCircle-font">博士后设站资助申报程序</div>
              </div>
              1.区人社局制发申报通知。<br />
              2.新设站单位按照申报通知要求，备齐材料，向武侯区人社局提出申请。<br />
              3.区人社局对申请材料予以受理、审核。<br />
              4.审核通过名单报区人社局党组审定。<br />
              5.对审定通过名单公示5个工作日，公示无异议的，按照财务相关规定，将资助资金拨付到设站单位指定账户。<br />
              <div class="commonCircle">
                <div
                  class="commonCircle-circle"
                  style="margin-right: 0.15rem"
                ></div>
                <div class="commonCircle-font">博士后生活资助申报程序</div>
              </div>
              1.区人社局制发申报通知。<br />
              2.符合条件的博士后研究人员，依托设站单位备齐材料，向武侯区人社局提出申请。<br />
              3.区人社局对申请材料予以受理、审核。<br />
              4.审核通过名单报区人社局党组审定。<br />
              5.对审定通过名单公示5个工作日，公示无异议的，按照财务相关规定，分阶段拨付资助资金。博士后人员在站每满1年（资助期最长2年），经设站单位考核合格后，区人社局按照财务相关规定将该年度资助资金拨付到博士后个人账户。<br />
              <div class="commonCircle">
                <div
                  class="commonCircle-circle"
                  style="margin-right: 0.15rem"
                ></div>
                <div class="commonCircle-font">博士后出站留武侯区工作奖励</div>
              </div>
              1.区人社局制发申报通知。<br />
              2.对武侯区博士后科研工作站、博士后创新实践基地出站留武侯区工作的博士后人员，出站后与武侯区企业签订劳动合同并购买社保（企业应依法在武侯区履行纳税或统计义务，工商注册、税务登记和统计关系原则上均应在武侯区），连续工作满1年后（1年内离开武侯区工作的，不享受此项奖励），向武侯区人社局提出资助申请。
              <br />
              3.区人社局对申请材料予以受理、审核。<br />
              4.审核通过名单报区人社局党组审定。<br />
              5.对审定通过名单公示5个工作日，在公示结束后按程序兑现支付，按照财务相关规定，将资助资金拨付到博士后个人账户。<br />
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="../../assets/imgs/wuhou/1/title4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-85355861">028-85355861</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              武侯区人社局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../../assets/imgs/147/code.png" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.commonCircle {
  display: flex;
  align-items: center;
  margin: 0.19rem 0;
  &-circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
  }
  &-font {
    font-size: 0.34rem;
    color: #333;
    font-weight: 600;
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    // height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-2.5rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.1rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
